module.exports = __webpack_public_path__ + "static/img/01@2x.5f22665c.png";